<h3 mat-dialog-title>Disable Autopay for {{data.organization ? data.organization.name : ''}}</h3>

<mat-dialog-content class="small-content">
    <p>Are you sure you want to disable autopay for {{data.organization ? data.organization.name : 'this organization'}}
        ?</p>
</mat-dialog-content>

<mat-dialog-actions>
    <button class="btn btn-outline-secondary" mat-dialog-close>
        Cancel
    </button>
    <button (click)="disableAutopay()" class="btn btn-primary">
        <i class="fa fa-check "></i>
        Yes, disable autopay
    </button>
</mat-dialog-actions>
